import React, {useState} from "react"
import {Button, Classes, Dialog} from "@blueprintjs/core"
import {DatePicker} from "@blueprintjs/datetime"
import Props from "./props"

export interface SelectProps extends Props {
    selectedValue: Date
    setSelectedValue: (value: Date) => void
    disabled?: boolean
}

const DatePickerDialog: React.FC<SelectProps> = (props) => {
    const {selectedValue, setSelectedValue, disabled} = props

    const [open, setOpen] = useState<boolean>(false)

    const getOnDayClick = () => {
        setOpen(false)
    }

    return (
        <div>
            <Button
                disabled={disabled}
                onClick={() => setOpen(true)}
                icon="caret-down"
            />
            <Dialog
                icon="info-sign"
                onClose={() => setOpen(false)}
                isOpen={open}
                usePortal
                title="Date"
            >
                <div className={Classes.DIALOG_BODY}>
                    <DatePicker
                        value={selectedValue}
                        onChange={(value: any) => {
                            setSelectedValue(value)
                        }}
                        dayPickerProps={{onDayClick: getOnDayClick}}
                        highlightCurrentDay={false}
                        reverseMonthAndYearMenus={false}
                        shortcuts={false}
                        showActionsBar={false}
                    />
                </div>
            </Dialog>
        </div>
    )
}

DatePickerDialog.defaultProps = {
    disabled: false,
}

export default DatePickerDialog
